import {
  MUTATION_NAME,
  DATA_ELEMENT_TYPE,
  FIELD_TYPE
} from "@/static/global-variables";
import services from "@/services";
import store from "@/store";

function _getInitialPromiseState() {
  return {
    promise: null,
    isFullfilled: false,
    isPending: false,
    isRejected: false
  };
}

class SfGlobalObjects {
  constructor() {
    this.globalObjects = _getInitialPromiseState();
    this.describeObjectMap = new Map();
    this.describeObjectsMap = new Map();
    this.metaObjectMap = new Map();
    this.VEEVA_CUSTOM_OBJECT_POSTFIX = "vod__c";
    this.SF_CUSTOM_OBJECT_POSTFIX = "__c";
  }

  fetchAvailableObjects() {
    const sfGlobalObjects = store.getters.sfGlobalObjects;
    if (sfGlobalObjects) {
      return Promise.resolve(sfGlobalObjects);
    }
    if (this.globalObjects.isPending) {
      return this.globalObjects.promise;
    }
    this.globalObjects.isPending = true;
    this.globalObjects.promise = services.fetchAvailableObjects();
    this.globalObjects.promise.then(
      res => {
        this.globalObjects.isFullfilled = true;
        this.globalObjects.isPending = false;
        store.dispatch(MUTATION_NAME.SET_SF_GLOBAL_OBJECTS, res);
      },
      e => {
        console.error(e);
        this.globalObjects.isRejected = true;
        this.globalObjects.isPending = false;
      }
    );
    return this.globalObjects.promise;
  }

  describeObject(objName) {
    if (!this.describeObjectMap[objName]) {
      this.describeObjectMap[objName] = _getInitialPromiseState();
    }
    const promiseState = this.describeObjectMap[objName];
    const objects = store.getters.sfObjectsInfo || {};
    const sfObjectsInfo = objects[objName];
    if (promiseState.isPending) {
      return promiseState.promise;
    }
    if (sfObjectsInfo) {
      return Promise.resolve(sfObjectsInfo);
    }
    promiseState.isPending = true;
    promiseState.promise = services.describeObject(objName);
    promiseState.promise.then(
      res => {
        promiseState.isFullfilled = true;
        promiseState.isPending = false;
        const data = store.getters.sfObjectsInfo || {}; // get most current to avoid overriding
        data[objName] = res;
        store.dispatch(MUTATION_NAME.SET_SF_OBJECTS_INFO, data);
      },
      e => {
        console.error(e);
        promiseState.isRejected = true;
        promiseState.isPending = false;
      }
    );
    return promiseState.promise;
  }
  fetchObjectMetaData(objName) {
    if (!this.metaObjectMap[objName]) {
      this.metaObjectMap[objName] = _getInitialPromiseState();
    }
    const promiseState = this.metaObjectMap[objName];
    const objects = store.getters.sfObjectsMeta || {};
    const sfObjectsMeta = objects[objName];
    if (promiseState.isPending) {
      return promiseState.promise;
    }
    if (sfObjectsMeta) {
      return Promise.resolve(sfObjectsMeta);
    }
    promiseState.isPending = true;
    promiseState.promise = services.fetchObjectMetaData(objName);
    promiseState.promise.then(
      res => {
        promiseState.isFullfilled = true;
        promiseState.isPending = false;
        const data = store.getters.sfObjectsMeta || {}; // get most current to avoid overriding
        data[objName] = res;
        store.dispatch(MUTATION_NAME.SET_SF_OBJECTS_META, data);
      },
      e => {
        console.error(e);
        promiseState.isRejected = true;
        promiseState.isPending = false;
      }
    );
    return promiseState.promise;
  }

  describeObjects(namesArray) {
    const objName = namesArray.join("-");
    if (!this.describeObjectsMap[objName]) {
      this.describeObjectsMap[objName] = _getInitialPromiseState();
    }
    const promiseState = this.describeObjectsMap[objName];
    const sfEntryPointOjbectsInfo = store.getters.sfEntryPointOjbectsInfo || {};
    if (promiseState.isPending) {
      return promiseState.promise;
    }
    let entryPointObject;
    if (sfEntryPointOjbectsInfo) {
      const set = new Set(Object.keys(sfEntryPointOjbectsInfo));
      entryPointObject = {};
      for (const name of namesArray) {
        if (set.has(name)) {
          entryPointObject[name] = sfEntryPointOjbectsInfo[name];
        } else {
          entryPointObject = null;
          break;
        }
      }
      if (entryPointObject) {
        return Promise.resolve(entryPointObject);
      }
    }
    promiseState.isPending = true;
    promiseState.promise = services.describeObjects(namesArray);
    promiseState.promise.then(
      res => {
        promiseState.isFullfilled = true;
        promiseState.isPending = false;
        const data = store.getters.sfEntryPointOjbectsInfo || {}; // get most current to avoid overriding
        for (const [key, entry] of Object.entries(res)) {
          data[key] = entry;
        }
        store.dispatch(MUTATION_NAME.SET_SF_ENTRY_POINT_OBJECTS_INFO, data);
      },
      e => {
        console.error(e);
        promiseState.isRejected = true;
        promiseState.isPending = false;
      }
    );
    return promiseState.promise;
  }

  updateObjectTags(de, objName, sfFields) {
    if (
      de.type === DATA_ELEMENT_TYPE.CRM_QUERY ||
      de.type === DATA_ELEMENT_TYPE.CONTEXT_QUERY
    ) {
      const objectTags = new Map();
      for (const [fieldName] of Object.entries(de.fields)) {
        const field = sfFields.find(e => e.name === fieldName);
        if (field) {
          if (
            field.originalType === FIELD_TYPE.REFERENCE &&
            field.referenceTo &&
            field.referenceTo.length > 0
          ) {
            objectTags.set(fieldName, field.referenceTo[0]);
          } else if (field.originalType === FIELD_TYPE.ID) {
            objectTags.set(fieldName, objName);
          }
        }
      }
      de.objectTags = Object.fromEntries(objectTags);
    }
  }
  /**
   * updatePicklistFields - Will query SF objects picklist fields, used for older CRM queries that did not include flag
   */
  updatePicklistFields(app, objectDescribeMap) {
    if (app.dataElements) {
      Object.values(app.dataElements).forEach(de => {
        if (de.fields && de.object) {
          const objName = de.object.name || de.object;
          const sfObject = objectDescribeMap[objName];
          if (sfObject) {
            const sfFields = sfObject.fields;
            if (de.type === DATA_ELEMENT_TYPE.CRM_QUERY) {
              for (const [fieldName] of Object.entries(de.fields)) {
                const field = sfFields.find(e => e.name === fieldName);
                de.fields[fieldName].isPicklist = !!(
                  field &&
                  (field.originalType === FIELD_TYPE.PICKLIST ||
                    field.originalType === FIELD_TYPE.MULTI_SELECT_PICKLIST)
                );
              }
            }
          }
        }
      });
    }
  }

  updateApp(app, updateFunction) {
    return new Promise((resolve, reject) => {
      if (app) {
        const promises = this.getDescribePromises(app);
        Promise.allSettled(promises).then(results => {
          let objectDescribeMap = {};
          results.forEach(r => {
            if (r.status === "fulfilled") {
              objectDescribeMap[r.value.name] = r.value;
            }
          });
          updateFunction(app, objectDescribeMap, this);
          resolve(app);
        });
      } else {
        reject({ error: "No app provided" });
      }
    });
  }

  /**
   * updateFieldLabels - Will query SF objects to get correct field labels depending on the users language on SF
   */
  updateFieldLabels(app, objectSFDCTranslationMap, self) {
    Object.values(app.dataElements).forEach(de => {
      if (de.fields && de.object) {
        const objName = de.object.name || de.object;
        const sfObject = objectSFDCTranslationMap[objName];
        if (sfObject) {
          if (typeof de.object === "string") {
            de.objectLabel = sfObject.label;
          } else {
            de.object.label = sfObject.label;
          }
          const sfFields = sfObject.fields;
          for (const [fieldName, obj] of Object.entries(de.fields)) {
            const field = sfFields.find(e => e.name === fieldName);
            if (field) {
              obj.label = field.label;
            }
          }
          self.updateObjectTags(de, objName, sfFields);
        }
      }
    });
  }

  getDescribePromises(app) {
    const promises = [];
    const objectNames = new Set(); // to keep track of requested objects
    if (app.dataElements) {
      for (const de of Object.values(app.dataElements)) {
        if (
          de.fields &&
          de.object &&
          de.type !== DATA_ELEMENT_TYPE.NITRO_QUERY
        ) {
          const dataElementName = de.object.name || de.object;
          if (!objectNames.has(dataElementName)) {
            objectNames.add(dataElementName);
            promises.push(this.describeObject(dataElementName));
          }
        }
      }
    }
    return promises;
  }
}

export default new SfGlobalObjects();
